import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { EnemySection } from '../components/EnemySection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatInsideSection } from '../components/WhatInsideSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { BonusSection } from '../components/BonusSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { CloseSection } from '../components/CloseSection';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-navy text-white selection:bg-gold selection:text-navy" data-id="element-189" data-mp="3qoyrelm50cx0">
      <HeroSection data-id="element-190" data-mp="3vmi3bevd4dls" />
      <PainSection data-id="element-191" data-mp="3vo2xh3drluj4" />
      <EnemySection data-id="element-192" data-mp="3vnjq2glqqojc" />
      <SolutionSection data-id="element-193" data-mp="3vp4km68227h7" />
      <WhatInsideSection data-id="element-194" data-mp="3ak8diam2xnpa" />
      <TestimonialsSection data-id="element-195" data-mp="3aki522mrw2x3" />
      <OfferSection data-id="element-196" data-mp="3alt7nz4hf4mm" />
      <BonusSection data-id="element-197" data-mp="35t04vgskq6d6" />
      <GuaranteeSection data-id="element-198" data-mp="35shxpp4di7qh" />
      <CloseSection data-id="element-199" data-mp="35s8842n8q2lb" />
    </main>;
}